export default __webpack_public_path__ + "static/media/posicao-estoque.21be5beb.png";